import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormBacteriumCountText } from './FormBacteriumCountText';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalBacteriumCounText = (props) => {

    const {
        modal, tittle, closeDialogB, method,
        name,
        handleInputChange, loading,
        saveCreate, saveUpdateBacterium
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialogB}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-medical f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateBacterium}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialogB}>
                        Cancelar
                    </Button>
                </>
            }

        >
            {
                method === "create"
                    ? <FormBacteriumCountText
                        button={"Crear"}
                        {...{ closeDialogB, loading, name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormBacteriumCountText
                            button={"Actualizar"}
                            {...{ closeDialogB, loading, name, handleInputChange, methodAction: saveUpdateBacterium }} />
                        :
                        null
            }
        </Dialog>
    )
}
